import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * ProgressStep のスタイル
 */
export const progressStepStyle = tv({
    slots: {
        base: ['grid grid-cols-3 gap-2', 'min-h-[86px] lg:min-h-[64px]'],
        step: [
            textStyle({
                color: 'textGray',
                isBold: true,
                size: { initial: 'xs', xl: 'md' },
            }),
            'shrink-0',
            'bg-gray-200',
            // 活性状態
            'aria-[current=step]:bg-white',
            'aria-[current=step]:text-primary',
        ],
        stepInner: ['flex flex-col lg:flex-row lg:items-center gap-4'],
        stepLink: [
            'flex items-center justify-center gap-4 lg:gap-8',
            'w-full h-full',
            'text-current',
        ],
    },
    variants: {
        /**
         * ステップの位置
         */
        stepPosition: {
            between: {
                step: [
                    'w-[calc(100%_+_35px)]',
                    '[clip-path:polygon(calc(100%_-_31px)_0%,_100%_50%,_calc(100%_-_31px)_100%,_0%_100%,_31px_50%,_0%_0%)]',
                    '-translate-x-[15px]',
                ],
                stepInner: ['-translate-x-2'],
            },
            first: {
                step: [
                    'w-[calc(100%_+_15px)]',
                    '[clip-path:polygon(0%_0%,_calc(100%_-_31px)_0%,_100%_50%,_calc(100%_-_31px)_100%,_0%_100%)]',
                ],
                stepInner: ['-translate-x-[15px]'],
            },
            last: {
                step: [
                    'w-[calc(100%_+_10px)]',
                    '[clip-path:polygon(100%_0,_100%_50%,_100%_100%,_0%_100%,_31px_50%,_0%_0%)]',
                    '-translate-x-[10px]',
                ],
                stepInner: ['translate-x-[15px]'],
            },
        },
    },
});
